/**
 * Vert tabs tab setup
 * This file gets shared between the
 * theme and editor.
 */
import tabs from '../util/tabs';

tabs('vert-tabs', {
	wrap: '.vert-tabs',
	toggles: ['.vert-tabs__nav-label', '.vert-tabs__acc-label'],
	content: '.vert-tabs__content',
});
